import * as def from '@/definitions'
import { PatternBaseLayer } from './patternBaseLayer'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { PathHelper } from '@/helper/pathHelper'
import { ArrayHelper } from '@/helper/arrayHelper';

// 円レイヤー
export class CircleLayer extends PatternBaseLayer
{
    public get layerType() : string { return "circle"; }

    public clone()
    {
        var cloned = new CircleLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : CircleLayer)
    {
        super.cloneParameter(layer);
    }

    // 作成
    public static create(x : number = 0, y : number = 0, width : number = 0, height : number = 0) : CircleLayer
    {
        var layer = new CircleLayer();
        layer.keepRatio = 0;
        layer.strokeColor = new ColorConstruct(0, 0, 0);
        layer.strokeWidth = 1.0;
        layer.fillType = 0;
        layer.fillColor = new ColorConstruct(51 ,153, 0);
        layer.rotate = 0;
        layer.width = width;
        layer.height = height;
        layer.x = x;
        layer.y = y;

        // 初期グラデーション
        layer.addGradation(0, new ColorConstruct(0, 255, 0));
        layer.addGradation(100, new ColorConstruct(255, 255,255));
        layer.linearGradationAngle = 0;
        
        return layer;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : CircleLayer
    {
        var layer = new CircleLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        super.loadParameterFromJson(jsonData);
    }
}